import React, { useEffect, useState } from "react";
import BreadCrumbs from "../../components/breadcrumbs";
import Banner from "../../components/img_bannerblogs";
import RCMcy from "../../images/BlogCardImgs/differencebetweenmedicalbillingandcredentialing1.webp";
import BlogImg12 from "../../images/BlogCardImgs/acersmedicalbillgtechniques1.webp";
import BlogImg10 from "../../images/BlogCardImgs/whatdoesbillingmeantopatients1.webp";
import BlogImg6 from "../../images/BlogCardImgs/howtoaccelerateclaimsprocessing1.webp";
import BlogImg4 from "../../images/BlogCardImgs/unveilingthecoreconceptsofehr.webp";
import Blogcontent from "../../img/Blogcontent1/blog content images 1.jpg";
import BillingCycle from "../../img/Blogbanners1/BillingVsCredentialing/Billing-Cycle.jpg";
import credentialCycle from "../../img/Blogbanners1/BillingVsCredentialing/Credentialing-Cyce.jpg";
import KeyDifference from "../../img/Blogbanners1/BillingVsCredentialing/key-differences.png";
import Keymistakes from "../../img/Blogbanners1/BillingVsCredentialing/Key-mistakes.jpg";
import Tablecontent from "../Blogs/Blogstablecontent";
import { Helmet } from 'react-helmet';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText,
  MDBCardBody,
} from "mdb-react-ui-kit";
// import DownContact from "../../components/downcontact";
// import Meta from "antd/es/card/Meta";
// import { Descriptions } from "antd";

const About = () => {
  useEffect(() => {
    // change title of page
    document.title = "What’s the Difference Between Medical Billing and Credentialing";
  }, []);


  // Set Banner Title
  // const [BannerTitle, setBannerTitle] = useState(
  //   "What’s the Difference Between Medical Billing and Credentialing?", img:`url(${RCMcy})`});
  // );
  const [BannerTitle, setBannerTitle] = useState({ title: "What’s the Difference Between Medical Billing and Credentialing", subtitle: "", img: `url(${RCMcy})` });

  // Set DownContact Heading
  const [DownContactTitle, setDownContactTitle] = useState({
    title: "WE HELP DOCTORS COLLECT MORE MONEY FASTER AND EASIER",
    subtitle:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  });

  return (
    <>
      <Helmet>
        <style>{` body { overflow-x: hidden; background-color: white;}`}</style>
        <title>Medical Billing vs. Credentialing: Key Differences | Acer Health</title>
        <link rel="canonical" href="https://acerhealth.com/blog/medical-billing-vs-credentialing" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "https://acerhealth.com/blog/medical-billing-vs-credentialing"
            },
            "headline": "What’s the Difference Between Medical Billing and Credentialing?",
            "description": "Learn the key differences between medical billing and credentialing, their step-by-step processes, and how both work together to support your healthcare practice.",
            "image": "https://acerhealth.com/assets/img/blog/medical-billing-vs-credentialing.jpg",
            "author": {
              "@type": "Organization",
              "name": "AcerHealth"
            },
            "publisher": {
              "@type": "Organization",
              "name": "AcerHealth",
              "logo": "%PUBLIC_URL%/favicon.png",
            },
            "datePublished": "2025-08-15",
            "dateModified": "2025-08-15"
          },
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "Is medical billing the same as credentialing?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No, they are two different processes. Medical billing involves submitting claims and collecting payments. Credentialing is about verifying a provider’s qualifications to work with insurance networks."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Who handles medical billing and credentialing in a clinic?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Many clinics either have separate teams or outsource these tasks. In smaller practices, office staff may handle both credentialing and billing responsibilities."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you need to complete credentialing before billing?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes. A provider must be credentialed with an insurance company before submitting claims. Otherwise, claims will be denied."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How long does credentialing take?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Credentialing usually takes 30 to 120 days, depending on the payer and how quickly all documentation is submitted."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can a medical billing company help with credentialing too?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, many full-service billing companies, like AcerHealth, also offer credentialing services to streamline the entire revenue cycle."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What happens if credentialing is delayed?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Delays in credentialing can prevent providers from billing for services, leading to lost revenue and disruptions in insurance participation."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What’s the best way to avoid issues with billing and credentialing?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Start credentialing early, stay organized, double-check provider data, and consider partnering with an experienced billing and credentialing service like AcerHealth."
                  }
                }
              ]
            }
          )}
        </script>
        <meta name="description" content="Understand the difference between medical billing and credentialing. Acer Health outlines how each affects your revenue cycle and daily operations"
        />
      </Helmet>
      <Banner BannerTitle={BannerTitle} />
      <div className="container mb-4 mt-4 d-flex">
        <div style={{ maxWidth: 'fit-content', width: 'fit-content' }}>
          <BreadCrumbs
            paths={[
              { name: "Home", link: "/" },
              { name: "Blogs", link: "/medical-billing-blogs" },
              { name: "What’s the Difference Between Medical Billing and Credentialing" }
            ]}
          />
        </div>
      </div>
      <div className="row" style={{ paddingRight: '10%', paddingLeft: '5%' }}>
        <MDBCol md="3" className="toc-sticky">
          <Tablecontent />
        </MDBCol>
        <MDBCol md="7" className="content" style={{ paddingRight: '50px' }}>
          <h1 style={{ textAlign: 'center', fontSize: '30px', fontFamily: "Alegreya Sans" }} className="mb-4"><b>What’s the Difference Between Medical Billing and Credentialing?</b></h1>

          <div className="mb-3">
            <img
              src={Blogcontent}
              alt="Medical Billing and Credentialing"
              className="img-fluid"
              width={500}
              height={500}
            />
          </div>
          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}>
            Understanding the Two Pillars of a Healthy Medical Practice
          </h2>
          <h2 style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}>
            <b> Introduction</b>
          </h2>
          <p className="justify-content-left" style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            textAlign: "justify",
            marginBottom: '8px', 
            lineHeight: '1.4'    
          }}>
            If you’re running a medical practice or helping manage one, chances are you’ve heard the terms medical billing and credentialing
            thrown around. They both sound like “admin tasks,” — and while that’s partially true, they play very different roles
            in how a healthcare practice runs and gets paid.
          </p>

          <p className="justify-content-left" style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            textAlign: "justify",
            marginBottom: '6px',
            lineHeight: '1.4'
          }}>
            In simple terms:
          </p>

          <ul style={{ paddingLeft: "20px", marginTop: '0', marginBottom: '0' }}>
            <li className="justify-content-left" style={{
              fontSize: '18px',
              fontFamily: "Alegreya Sans",
              fontWeight: '500',
              marginBottom: '4px',
              lineHeight: '1.4'
            }}>
              Credentialing is about getting permission to see patients and bill insurance companies.
            </li>

            <li className="justify-content-left" style={{
              fontSize: '18px',
              fontFamily: "Alegreya Sans",
              fontWeight: '500',
              marginBottom: '0',
              lineHeight: '1.4'
            }}>
              Medical billing is how you collect the money for the care you provide.
            </li>
          </ul>

          <p className="justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
           Both are essential. And if either one isn’t done right, it can delay payments or stop them altogether. Let’s walk through the full
            journey of how a patient visit turns into a payment for the healthcare provider. Understanding the complete  <a
                            href="https://acerhealth.com/blog/medical-billing-process"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                           medical billing process
                        </a>
            helps U.S. healthcare practices improve claim accuracy, reduce reimbursement delays, and strengthen overall revenue cycle performance.
          </p>


          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}>
            What is Medical Billing?
          </h2>

          <p className="justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Medical billing is the practice of converting the healthcare services provided by a doctor or clinic into financial claims and requesting
             payment from insurance companies or patients. Understanding the different  <a
                            href="http://acerhealth.com/blog/types-of-medical-billing-and-rcm-impact"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                        >
                           types of medical billing 
                        </a>can help healthcare practices select
              workflows that align with their specialty, payer mix, and reimbursement goals.
          </p>
          <h3 style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}> <b>Think of It Like This:</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Think of medical billing as the bridge between the care a patient receives and the payment a healthcare provider earns. When a doctor treats a patient,
            that care needs to be paid for — not by the doctor or clinic themselves, but typically by an insurance company on the patient’s behalf. </p>
          <p className="justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Medical billing helps make that happen. It ensures that every service a patient received is correctly recorded and billed, so the clinic or hospital gets properly reimbursed.
            It’s an essential part of running any healthcare practice, because even the best care can't continue if the business behind it doesn't function smoothly.
          </p>

          <p className="justify-content-left" style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            In short, medical billing is how healthcare providers get paid for the work they do.  </p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontSize: '25px' }}> <b>Step-by-Step: How Medical Billing Works  </b></h3>


          <div className="mb-3">
            <img
              src={BillingCycle}
              alt="Medical billing cycle infographic showing steps like patient registration, insurance verification, coding, claim submission, and denial management."
              className="img-fluid"
              width={400}
              height={400}
            />
          </div>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>Let’s walk through the full journey of how a patient
            visit turns into a payment for the healthcare provider.</p>
          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>1. Patient Registration</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            This is the very first step when a patient books an appointment or walks into your clinic.
            Your front desk staff gathers key information like:
          </p>

          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px',

          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Full name</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Date of birth</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Insurance provider and policy number</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Contact details</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Reason for visit (if known)</li>
          </ul>


          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginTop: '0px',
            textAlign: "justify"
          }}>
            This data is used to create or update the patient’s profile in your system. Accurate information here helps avoid claim rejections later.
          </p>

          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>2. Insurance Verification</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Before the patient is seen, your team checks their insurance details to make sure:
          </p>

          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>The policy is still active</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>The planned services are covered</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>The co-pay, deductible, or referral requirements are known</li>

          </ul>


          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginTop: '0px',
            textAlign: "justify"
          }}>
            This step helps you avoid surprises like claim denials or unpaid balances. It also helps you inform the patient
            in advance if they’ll need to pay anything out of pocket.
          </p>


          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>3. Medical Coding</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            After the patient has seen the doctor, the visit is documented in detail — everything from diagnosis to treatments or procedures done.
          </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Then comes <b>coding </b>— a trained medical coder translates this into universal codes such as:  </p>

          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
              <a
                href="https://www.icd10data.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
              >
                ICD-10
              </a>for diagnosis</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
              <a
                href="https://www.cms.gov/medicare/coding-billing/healthcare-common-procedure-system"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
              >
                CPT/HCPCS
              </a> for procedures and services</li>


          </ul>


          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginTop: '0px',
            textAlign: "justify"
          }}>
            These codes are essential. They tell the insurance what happened and justify the payment request. </p>
          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>4. Charge Entry</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Once coded, all the procedures and services are entered into your billing software or EMR (Electronic Medical Record) system.
          </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Each code is linked to a charge amount. This becomes the foundation for the claim you’ll submit.  </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Accuracy is key here — a small mistake can delay the entire payment process.  </p>

          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>5. Claim Submission</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Now, the complete claim (with patient info, provider details, codes, and charges) is submitted to the patient’s insurance company.
          </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px',
            textAlign: "justify"
          }}>
            Most practices do this electronically via clearinghouses. Some still submit by paper. </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            This step officially requests payment for the services rendered. </p>


          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>6. Payment Posting</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            The insurance company reviews the claim and, if everything looks good, processes the payment.
          </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Your billing team receives an <b>EOB (Explanation of Benefits) </b>and posts the payment into the system. </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            If the patient owes part of the bill (like a co-pay or coinsurance), they’re sent a statement. </p>

          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>7. Denial Management</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Sometimes claims get denied or partially paid.
          </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>

            Maybe the code was wrong, a service wasn’t covered, or the patient wasn’t eligible on the service date.
          </p>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            In this case, your billing team needs to: </p>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Investigate the reason for denial</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Correct the issue</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Resubmit the claim or appeal the decision</li>

          </ul>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Strong
            <a
              href="https://acerhealth.com/services/denial-management-services"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              denial management
            </a>  keeps your revenue from slipping through the cracks. </p>


          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>8. Patient Collections</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Even after insurance pays, some balance may remain. Your team:
          </p>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Sends bills to patients</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Follows up with reminders or phone calls</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Offers payment plans if needed</li>

          </ul>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Clear and timely communication here helps ensure that the patient pays what they owe — and avoids confusion or frustration.
          </p>

          <h4 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>9.Reporting & Auditing</h4>

          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Finally, your billing team reviews monthly or weekly reports to:
          </p>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Check collections</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Track denial trends</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Spot delays</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Ensure everything is running smoothly</li>

          </ul>
          <p style={{
            fontSize: '18px',
            fontFamily: "Alegreya Sans",
            fontWeight: '500',
            marginBottom: '6px'
          }}>
            Regular audits also help you stay compliant and uncover any issues before they become big problems.
          </p>

          <h3 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2" style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>
            Summary
          </h3>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Medical billing is more than just sending bills. It’s a complete process — from collecting correct patient info all the way to analyzing
            reports and handling denials. When done well, it keeps your cash flow steady and your practice healthy.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Learn more here:
            <a
              href="https://acerhealth.com/services/medical-billing-services"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              AcerHealth’s Medical Billing Services
            </a></p>
          <h2 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold', fontSize: '26px' }}>What is Credentialing?</h2>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Credentialing is a separate but equally important process. It’s about verifying that a healthcare provider is qualified,
            licensed, and approved by insurance companies to see patients and receive reimbursement.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            If credentialing isn’t done or is done incorrectly, you simply can’t bill insurance companies — even if the services were provided.</p>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Think of credentialing like getting a driver’s license. You need that before you can hit the road. In the same way,
            a provider must be credentialed before billing insurers like
            <a
              href="https://www.cms.gov/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              Medicare, Medicaid,
            </a> or private payers.</p>



          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold', fontSize: '26px' }}>Step-by-Step: How Credentialing Works </h3>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Credentialing is all about making sure a healthcare provider is qualified and authorized to treat patients — and to get paid by insurance companies.
            It’s a vital step that ensures trust, safety, and compliance.</p>

          <div className="mb-3">
            <img
              src={credentialCycle}
              alt="Credentialing cycle infographic outlining steps like provider information gathering, CAQH enrollment, payer enrollment, and re-credentialing."
              className="img-fluid"
              width={400}
              height={400}
            />
          </div>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Let’s walk through each step more clearly:</p>

          <h4 style={{ fontSize: '25px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>1. Gather Provider Information</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Before anything begins, the provider (doctor, nurse practitioner, etc.) must collect all important documents
            and details that prove they are licensed and capable of practicing medicine.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Includes things like:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>State medical license(s)</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>DEA certificate (to prescribe medication)</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Board certification(s)</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Malpractice insurance coverage</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Educational background and degrees</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Work history and references</li>

          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            This information shows insurers and hospitals that the provider is properly trained, qualified, and covered legally and professionally.</p>

          <h4 style={{ fontSize: '20px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>2. CAQH Enrollment (ProView Profile)</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            CAQH ProView is an online system where most insurance companies check provider credentials.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What providers do:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Create a profile on
              <a
                href="https://proview.caqh.org/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
              >
                https://proview.caqh.org/
              </a></li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>Enter their details — licenses, training, NPI number, etc.</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Authorize payers to view their data</li>


          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            It’s a central place that streamlines the credentialing process for multiple insurance companies at once.</p>


          <h4 style={{ fontSize: '25px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>3. Primary Source Verification</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Insurance companies don’t just take your word for it — they verify everything with the original sources.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>They’ll check with:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Medical schools to confirm degrees</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Licensing boards to verify active licenses</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>		DEA for prescribing privileges</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Certification boards to confirm specialty credentials</li>

          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            This step ensures there’s no fraud or outdated info — it builds trust between providers and insurers.</p>



          <h4 style={{ fontSize: '25px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>4. Payer Enrollment</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Now that all documents are ready and verified, the provider applies to each insurance company they want to work with.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What happens:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Fill out specific forms for each payer (like Medicare, Blue Cross, Aetna, etc.)</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Include supporting documents</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Submit applications via CAQH or directly on the payer’s portal</li>

          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Without this, providers can’t bill insurance companies — they won’t be considered part of the insurer’s network.</p>

          <h4 style={{ fontSize: '25px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>5. Ongoing Communication</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>
            Insurance companies might ask for more info, clarifications, or corrections during their review process.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Tasks may include:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Responding to missing documentation requests</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Fixing small errors</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Sending updated copies of licenses or insurance</li>

          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Prompt responses avoid delays. Credentialing can already take weeks or months — slow replies make it longer.</p>


          <h4 style={{ fontSize: '25px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>6. Approval / Network Participation</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            If everything checks out, the provider is officially credentialed and becomes part of the insurance network.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What happens next:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	The provider receives a welcome letter or notice</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>		Assigned a billing ID for that payer</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Can now start seeing patients covered under that insurance</li>

          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Only credentialed, in-network providers can submit claims and get reimbursed properly.</p>



          <h4 style={{ fontSize: '25px', fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>7. Re-Credentialing (Every 2–3 Years)</h4>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What it means:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing isn’t a one-time thing. Providers need to reverify their qualifications periodically.</p>

          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>What’s required:</h5>
          <ul style={{
            fontSize: "17.5px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            listStyleType: "disc",
            paddingLeft: "18px",
            marginTop: '0px',
            marginBottom: '6px'
          }}>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Update
              <a
                href="https://proview.caqh.org/Login/Index?ReturnUrl=%2f"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
              >
                CAQH profiles
              </a>
            </li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>		Submit fresh copies of licenses, certificates, and insurance</li>
            <li style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500' }}>	Confirm ongoing education or training</li>

          </ul>
          <h5 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold' }}>Why it matters:</h5>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            This keeps payer records accurate and ensures continued trust and compliance with healthcare laws.</p>



          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold', fontSize: '26px' }}>Summary  </h3>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing can feel tedious, but it's absolutely essential. It protects patients,
            supports providers, and ensures the entire healthcare system runs smoothly. Think of it as a license to practice and get paid.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            More on this here:
            <a
              href="https://acerhealth.com/services/medical-billing-and-credentialing"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              AcerHealth’s Credentialing Services
            </a></p>

          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '28px' }}>Medical Billing vs Credentialing: The Key Differences </h2>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Here’s a simple side-by-side comparison:</p>
          <div className="mb-3">
            <img
              src={KeyDifference}
              alt="Side-by-side comparison chart of medical billing vs. credentialing highlighting purpose, timing, roles, frequency, and tools."
              className="img-fluid"
              width={500}
              height={500}
            />
          </div>
          <h2 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontWeight: 'bold', fontSize: '26px' }}>Why Both Are Equally Important</h2>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing and billing are two sides of the same coin — and both are essential to keeping your practice financially healthy. Together, 
            they play a critical role in  <a
              href="https://acerhealth.com/blog/revenue-cycle-management-in-healthcare"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
            revenue cycle management
            </a>, helping healthcare organizations maintain steady cash flow and improve reimbursement 
            efficiency across the patient journey.</p>

                      <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
           Healthcare practices looking to strengthen both billing accuracy and reimbursement performance can also explore our<a
              href="https://acerhealth.com/blog/ultimate-guide-to-medical-billing"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
          complete guide to medical billing for small medical practices
            </a>,which explains the complete billing workflow, revenue cycle optimization strategies, and best practices for improving financial performance.</p>
            
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing comes first. It’s what allows a provider to be recognized by insurance companies. Without it, you simply can’t get paid.
            Think of it as getting your ticket to participate in a payer’s network. Until that’s in place, you’re not allowed to submit claims for reimbursement.</p>
            
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Once credentialing is complete, billing takes over. This is the process of submitting claims, tracking payments, correcting denials, and
            ensuring your practice gets paid for the care it provides. If billing is done poorly — whether due to coding errors, missed deadlines,
            or incorrect information — payments may be delayed, reduced, or even rejected.</p>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            In short, if credentialing isn’t handled properly, you won’t be able to bill at all. And if billing isn’t done correctly, you may still lose money even with full credentialing.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            That’s why both systems need to run smoothly and in sync. Any gaps in either area can create cash flow problems — something no practice can afford.
            When credentialing and billing teams work together, revenue flows better, faster, and more consistently.</p>

          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '28px' }}>Key Mistakes That Undermine Success</h2>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            When it comes to credentialing and medical billing, even minor oversights can lead to significant setbacks. Here are some of the most common mistakes that healthcare
            practices encounter — and why it's essential to stay ahead of them.</p>
          <div className="mb-3">
            <img
              src={Keymistakes}
              alt="Common medical billing and credentialing mistakes infographic, including billing before credentialing, missing documentation, and not tracking denials."
              className="img-fluid"
              width={500}
              height={500}
            />
          </div>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '26px' }}><b>Billing before credentialing is complete</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Some practices start submitting insurance claims for a provider before that provider is officially credentialed. Unfortunately, this usually leads to automatic
            denials and lost revenue. Insurance companies won’t process claims for someone who isn’t yet approved in their system. Always wait until credentialing
            is 100% done before billing.</p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '26px' }}><b>Missing documentation during credentialing</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing involves a lot of paperwork — licenses, board certifications, insurance documents, education records, and more. Missing or outdated documents, like an expired license or an incomplete CAQH profile,
            can hold up the process for weeks. It's essential to keep everything current and double-check all submissions.</p>


          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '26px' }}><b>Not following up with payers</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing isn’t a quick process, and payers often take their time. Without regular follow-up, an application can sit idle for months. Practices that don’t check in
            may assume things are moving along when they’re actually stuck. Staying in touch with payers is key to keeping the process on track.</p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '26px' }}><b>Forgetting re-credentialing deadlines</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Credentialing doesn’t end once a provider is approved. Re-credentialing is usually required by insurance
            companies every two to three years. If this is missed, the provider is removed from the network — and claims
            will stop being paid. It’s important to set reminders and track these deadlines carefully to avoid disruptions.</p>


          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '26px' }}><b>Not tracking claim denials</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            When claims are denied, it's often due to credentialing issues, outdated information, or simple data entry errors.
            If these denials aren’t reviewed and corrected, it can lead to significant revenue loss. Regularly monitoring and
            addressing denials ensures you’re not missing out on income that could be recovered.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Being proactive with credentialing and billing processes can save your practice time, money, and a
            lot of unnecessary stress. A little organization goes a long way.</p>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Read More:
            <a
              href="https://acerhealth.com/blog/denial-management-guide"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              Denial Management in Medical Billing
            </a></p>


          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '28px' }}>How AcerHealth Can Support Your Practice</h2>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            At AcerHealth, we provide comprehensive credentialing and medical billing solutions tailored to
            practices of all sizes. Our experienced teams are equipped to identify potential gaps, minimize delays, and
            <a
              href="https://acerhealth.com/services/revenue-cycle-management"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              optimize your revenue cycle
            </a>   — all while ensuring regulatory compliance and reducing administrative burden.</p>


          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            By integrating both credentialing and billing services, we help streamline operations and ensure a seamless transition from provider enrollment to claim reimbursement.</p>


          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            <b>Looking for a more efficient way to manage your revenue cycle?</b></p>


          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify"  }}>
            <a
              href="https://acerhealth.com/contact-us"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              https://acerhealth.com/contact-us
            </a>
            and let’s explore how we can support your success.</p>



          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '28px' }}>Final Thoughts</h2>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Medical billing and credentialing may serve different functions, but they work hand in hand to keep your practice financially healthy.
            Credentialing is what allows providers to join insurance networks and legally submit claims. Billing is the process that ensures
            those claims are accurately processed and reimbursed.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Both areas are complex, time-consuming, and require close attention to detail — yet both are absolutely essential
            for maintaining a stable and profitable healthcare operation.
            Without credentialing, there’s no access to payer networks. Without billing, there’s no revenue.</p>

          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            If you're unsure how to navigate either process, you're not alone — and you don't have to manage it alone. At
            <a
              href="https://acerhealth.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              AcerHealth,
            </a>
            we’re here to simplify each step, reduce administrative stress, and help your practice run
            more smoothly — so you can stay focused on delivering excellent care to your patients.</p>


          <h2 className="title AcerhealthTextPurple fontfamilyAvenir fontsizeset2 mb-2"
            style={{ fontFamily: "Alegreya Sans", fontSize: '28px' }}>Frequently Asked Questions (FAQs)</h2>


          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q.  Is medical billing the same as credentialing?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            No, they are two different processes. Medical billing is about sending claims to insurance companies and collecting payments.
            Credentialing is about verifying a healthcare provider’s qualifications so they can work with insurance networks.</p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q.  Who handles medical billing and credentialing in a clinic?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Many practices either have separate teams for each task or outsource them to specialized companies. Sometimes, especially in small practices, the same office staff may manage both.</p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q.  Do you need to complete credentialing before billing?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Yes, usually. A provider must be credentialed with an insurance company before they can bill that payer for services. Otherwise, the claims will be denied.</p>


          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q.  How long does Credentialing take?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            It can take anywhere from 30 to 120 days depending on the insurance company and how quickly all documents are submitted.</p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q. Can a medical billing company help with credentialing too?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Yes, many full-service
            <a
              href="https://acerhealth.com/about-us"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              medical billing companies
            </a>
            offer credentialing support. This is especially helpful for new practices or providers joining new networks.</p>


          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q. What happens if credentialing is delayed?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            If credentialing isn’t completed in time, providers may not get paid for services rendered, or they may need to wait or re-bill later. It can also affect patient trust and insurance participation.</p>

          <h3 style={{ fontFamily: "Alegreya Sans", fontWeight: '400', fontSize: '25px' }}><b>Q. What’s the best way to avoid issues with billing and credentialing?</b></h3>
          <p style={{ fontSize: '18px', fontFamily: "Alegreya Sans", fontWeight: '500', textAlign: "justify" }}>
            Stay organized, start credentialing early, double-check provider information, and consider partnering with a reliable
            <a
              href="https://acerhealth.com/services/medical-billing-and-credentialing"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
            >
              medical billing and credentialing service
            </a>
            provider.

          </p>

          <a href="/" className="text-reset" style={{ color: 'red' }}>
            <button style={{ background: '#3B0075', color: 'white' }}>Learn more</button>
          </a>
          <hr className="style-eight" />
        

        </MDBCol>
        <MDBCol md="2" className="content" style={{ paddingLeft: '30px' }}>
          <MDBRow className="row-cols-1 row-cols-md-4 g-4">
            <MDBCol md="12">
              <MDBRow>
                <MDBCard className="cardtest1 p-0" style={{ backgroundColor: '#f0f4fb', width: '300px' }}>
                  <MDBCardImage
                    src={BlogImg12}
                    alt="Obtain Billing Services from the Best Medical Billing
                  Company"
                    position="top"
                  />
                  <MDBCardBody>
                    <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      <a href="acerhealth_medicalbilling_techniques">
                        AcerHealth's Medical Billing Techniques
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard className="cardtest1 p-0" style={{ backgroundColor: '#f0f4fb', width: '300px' }}>
                  <MDBCardImage
                    src={BlogImg10}
                    alt="Choosing to Outsource Your Medical Billing is a Smart Decision?"
                    position="top"
                  />
                  <MDBCardBody>
                    <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      <a href="what-billing-means-for-patients">
                        What Does Billing Mean to Patients
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard className="cardtest1 p-0" style={{ backgroundColor: '#f0f4fb', width: '300px' }}>
                  <MDBCardImage
                    src={BlogImg6}
                    alt="Management of the Healthcare Revenue Cycle"
                    position="top"
                  />
                  <MDBCardBody>
                    <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      <a href="how_to_accelerate_claims_processing_technology">
                        How to Accelerate Claims Processing Technology
                      </a>
                    </div>
                    <MDBCardText className="pb-4">
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
            <MDBCol md="12">
              <MDBRow>
                <MDBCard className="cardtest1 p-0" style={{ backgroundColor: '#f0f4fb', width: '300px' }}>
                  <MDBCardImage
                    src={BlogImg4}
                    alt="Details about Patients is Protected by AcerHealth"
                    position="top"
                  />
                  <MDBCardBody>
                    <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                      <a href="unveiling_the_core_concepts_of_electronic_health_records_EHRs">
                        Unveiling the Core Concepts of Electronic Health Records
                        (EHRs)
                      </a>
                    </div>
                    <MDBCardText>
                      <small className="text-muted">
                        AcerHealth | Aug - 2024
                      </small>
                    </MDBCardText>
                  </MDBCardBody>
                </MDBCard>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </MDBCol>
   <div className="row" style={{ paddingRight: "10%", paddingLeft: "5%" }}>

  <MDBRow className="row-cols-1 row-cols-md-4 g-4 mb-2 d-flex">
            <MDBCol className="d-flex flex-column">
              <MDBCard className="cardtest1" style={{ backgroundColor: '#f0f4fb', height: '100%' }}>
                <MDBCardImage
                  src={BlogImg12}
                  alt="AcerHealth's Medical Billing Techniques"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    <a href="acerhealth_medicalbilling_techniques">
                      AcerHealth's Medical Billing Techniques
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard className="cardtest1" style={{ backgroundColor: '#f0f4fb', height: '100%' }}>
                <MDBCardImage
                  src={BlogImg10}
                  alt="What Does Billing Mean to Patients"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    <a href="what-billing-means-for-patients">
                      What Does Billing Mean to Patients
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard className="cardtest1" style={{ backgroundColor: '#f0f4fb', height: '100%' }}>
                <MDBCardImage
                  src={BlogImg6}
                  alt="How to Accelerate Claims Processing Technology"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    <a href="how_to_accelerate_claims_processing_technology">
                      How to Accelerate Claims Processing Technology
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>

            <MDBCol className="d-flex flex-column">
              <MDBCard className="cardtest1" style={{ backgroundColor: '#f0f4fb', height: '100%' }}>
                <MDBCardImage
                  src={BlogImg4}
                  alt="Unveiling the Core Concepts of Electronic Health Records"
                  position="top"
                />
                <MDBCardBody className="d-flex flex-column">
                  <div className="cardtitletest" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold' }}>
                    <a href="unveiling_the_core_concepts_of_electronic_health_records_EHRs">
                      Unveiling the Core Concepts of Electronic Health Records (EHRs)
                    </a>
                  </div>
                  <MDBCardText>
                    <small className="text-muted">
                      AcerHealth | Aug - 2024
                    </small>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>



   </div>


      </div>
      {/* <DownContact DownContactTitle={DownContactTitle} /> */}
    </>
  );
};

export default About;
